import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link, useLocation } from "react-router-dom";
import { Timer } from "lucide-react";
import { useTranslation } from "react-i18next";
import { readPendingClaim, clearPendingClaim, onPendingClaimChange } from "@/lib/pendingClaim";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const FUNNEL = ["/pricing", "/subscribe", "/login", "/confirm-account", "/magic-login"];

// Shown only across the signup -> subscribe -> pay stretch, and only while a live pending claim exists.
export const PendingClaimBanner = () => {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const [pos, setPos] = useState(() => readPendingClaim());
  const [open, setOpen] = useState(null); // null = not loaded yet
  const [gone, setGone] = useState(null);
  const inFunnel = FUNNEL.includes(pathname);

  useEffect(() => onPendingClaimChange(() => setPos(readPendingClaim())), []);
  useEffect(() => { setPos(readPendingClaim()); }, [pathname]);
  useEffect(() => {
    if (!pos || !inFunnel) return;
    axios.get(`${API}/positions/open`).then(({ data }) => setOpen((data.listings || []).map((l) => l.position))).catch(() => {});
  }, [pos, inFunnel]);
  useEffect(() => {
    // The strip on /pricing owns the "taken" message there; elsewhere the banner says it.
    if (pos && open && !open.includes(pos) && pathname !== "/pricing") { setGone(pos); clearPendingClaim(); }
  }, [pos, open, pathname]);

  if (!inFunnel) return null;
  if (gone && pathname !== "/pricing") {
    return (
      <div data-testid="pending-claim-gone-banner" className="fixed bottom-4 left-1/2 -translate-x-1/2 z-[96] max-w-xl w-[94%] px-4 py-3 rounded-2xl text-sm"
        style={{ background: "var(--bg-surface)", border: "1.5px solid var(--border-color)", color: "var(--text-primary)", boxShadow: "0 12px 40px rgba(0,0,0,0.22)" }}>
        {t("commerce.pendingClaimGone", { position: gone })}{" "}
        <Link to="/pricing" data-testid="pending-claim-gone-link" className="font-semibold" style={{ color: "var(--accent-primary)" }}>{t("commerce.openPositionsTitle")}</Link>
      </div>
    );
  }
  if (!pos || !open || !open.includes(pos)) return null;
  return (
    <div data-testid="pending-claim-banner" className="fixed bottom-4 left-1/2 -translate-x-1/2 z-[96] max-w-xl w-[94%] flex items-start gap-3 px-4 py-3 rounded-2xl"
      style={{ background: "var(--bg-surface)", border: "1.5px solid #f5b301", boxShadow: "0 12px 40px rgba(0,0,0,0.22)" }}>
      <Timer size={18} className="flex-shrink-0 mt-0.5" style={{ color: "#f5b301" }} />
      <p className="text-sm" style={{ color: "var(--text-primary)" }} data-testid="pending-claim-banner-text">
        {t("commerce.pendingClaimBanner", { position: pos })}
      </p>
    </div>
  );
};

export default PendingClaimBanner;
